import { FormDivider, FormParagraph } from '@frontend/components/elements/common';
import { FormLabel, FormSection, HorizontalFormGroupRead, InputContainer } from '@frontend/components/elements/forms';
import type { ICustomControlData } from './customControlData';

export function AdviesBijAfwijkendeBeoordelingRead({
    adviesBijAfwijkendeBeoordeling,
    adviesBijAfwijkendeBeoordelingVraag,
}: ICustomControlData) {
    if (!adviesBijAfwijkendeBeoordeling) {
        return null;
    }

    return (
        <>
            <FormDivider />
            <FormSection
                isBorderLess
                title="Advies"
            >
                <HorizontalFormGroupRead>
                    <FormLabel>Consultvraag indien afwijkend</FormLabel>
                    <InputContainer>
                        <FormParagraph>{adviesBijAfwijkendeBeoordeling}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>

                {adviesBijAfwijkendeBeoordeling === 'Ja' && (
                    <HorizontalFormGroupRead>
                        <FormLabel>Vraag aan de specialist</FormLabel>
                        <InputContainer>
                            <FormParagraph>{adviesBijAfwijkendeBeoordelingVraag}</FormParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}
            </FormSection>
        </>
    );
}
